import { principles, testimonials } from "@/mocks/site";

export default function AboutValues() {
  return (
    <section aria-label="发展理念与内容原则" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-secondary-600">
              <span className="h-1 w-6 bg-secondary-500"></span>
              发展理念
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              慢一点，但把话说清楚
            </h2>
            <div className="mt-5 space-y-4 text-sm leading-[1.9] text-foreground-700">
              <p>
                我们内部有一条不成文的规矩：一条线索如果无法给出至少三条可交叉验证的依据，就暂时不写。
                这不是保守，而是对读者的时间负责。
              </p>
              <p>
                第二，同一件事件我们只发一篇深度内容。后续进展在原稿上更新，不做重复发稿来刷存在感。
                这样读者永远只需要看一篇，就能掌握完整脉络。
              </p>
              <p>
                第三，我们不做标题党。标题里出现的信息，必须在正文中有对应的事实支撑。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <h3 className="font-heading text-lg font-bold text-foreground-950">我们的四条内容原则</h3>
            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((item) => (
                <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <h4 className="mt-3 font-heading text-base font-semibold text-foreground-950">
                    {item.title}
                  </h4>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14">
          <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-accent-700">
            <span className="h-1 w-6 bg-accent-500"></span>
            读者口碑
          </p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            他们这样评价我们
          </h2>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {testimonials.map((item) => (
              <figure key={item.name} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-5 w-5 items-center justify-center text-accent-500">
                  <i className="ri-double-quotes-l"></i>
                </span>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.text}
                </blockquote>
                <figcaption className="mt-4 border-t border-background-200 pt-4">
                  <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">{item.role}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}